import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import s from "./CategoryCarItem.module.scss";
import {
  ArrowUpOutlined,
  CrownOutlined,
  EyeOutlined,
  HeartOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getCarDetails } from "../../redux/carSlice";
import { useTranslation } from "react-i18next";

const CategoryCarItem = ({ car }) => {
  const [isHovered, setIsHovered] = useState();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div
      className={s.carCatalogueItem}
      onClick={() => {
        dispatch(getCarDetails(car?.id));
        navigate(`/car/${car.id}`);
      }}
    >
      <div
        className={s.carItem}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={s.img_wrapper}>
          {car.urgent ? <div className={s.urgent}>{t("urgent")}</div> : null}
          {car.vip ? (
            <div className={s.vip}>
              {" "}
              <CrownOutlined />
              &nbsp;VIP
            </div>
          ) : null}
          {
            <img
              src={car?.images[0]?.image || "/no-image.png"}
              className={s.car_img}
            />
          }
        </div>
        {/* <div className={s.car_desc}>
          <div>{car?.brand?.name}</div> &nbsp;
          <div>{car?.model?.name}</div>
        </div> */}
        {isHovered ? (
          <div className={s.hovered}>
            <div className='carousel'>
              <div
                className='slides'
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
              >
                {car?.images?.map((image, index) => (
                  <div key={index} className='slide'>
                    <img src={image.image} alt={`Slide ${index + 1}`} />
                  </div>
                ))}
              </div>
              <div className={s.dots}>
                {car?.images?.map((_, index) => (
                  <span
                    key={index}
                    className={index === activeIndex ? "dot active" : "dot"}
                    onMouseEnter={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className={s.car_info}>
        <div className={s.car_name}>
          <div className={s.brand}>{car?.brand?.name}</div> &nbsp;
          <div className={s.model}>{car?.model?.name}</div>
        </div>
        <div className={s.car_price}>
          <div className={s.price_usd}>{car?.price} USD</div>
          <div className={s.price_kgs}>{car?.price * 90} KGS</div>
        </div>
        <div className={s.car_icons}>
          <div className={s.views}>
            <EyeOutlined className={s.icon} /> &nbsp;100
          </div>
          &nbsp;
          <div className={s.likes}>
            <HeartOutlined className={s.icon} />
            &nbsp;20
          </div>
          &nbsp;
          <div className={s.likes}>
            <MessageOutlined className={s.icon} />
            &nbsp; 2
          </div>
        </div>

        <div className={s.car_text}>{car?.description}</div>
        <div className={s.bottom_btns}>
          <div className={s.location}>{"г.Бишкек"}</div>
          <div className={s.updated}>
            <ArrowUpOutlined /> {car?.up_time}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCarItem;
